import Swiper from 'swiper';
import {mediaQueryBreakpoints} from "../Utils/Utils";

const PeopleSlideshow = (domEl) => {

	let swiper = null;
	const breakpoint = window.matchMedia( `(min-width:${mediaQueryBreakpoints.md}px)` );

	const breakpointChecker = () => {
		// if larger viewport and multi-row layout needed
		if(breakpoint.matches === true) {
			// clean up old instances and inline styles when available
			if(swiper) {
				swiper.destroy( true, true );
			}
		}
		else if(breakpoint.matches === false) {
			// fire small viewport version of swiper
			return initializeSwiper();
		}
	};

	const initializeSwiper = () => {

		swiper = new Swiper(domEl, {
			loop: false,
			autoplay: false,
			speed: 400,
			spaceBetween: 20,
			slidesPerView: 'auto',
			wrapperClass: 'wp-block-columns',
			slideClass: 'wp-block-column',
		});
	}

	// keep an eye on viewport size changes
	breakpoint.addEventListener('change', () => {
		breakpointChecker();
	});
	//breakpoint.addListener(breakpointChecker);
	breakpointChecker();

};

export default PeopleSlideshow;